import React, { Component } from 'react'
import onClickOutside from 'react-onclickoutside'
import TextInputUI from './TextInputUI.js'

class TextInputSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value
    }
  }

  render() {
    return (
      <TextInputUI
        value={this.state.value}
        onChange={this.onChange}
        onSubmit={this.onSubmit}
        onCancel={this.props.onCancel}
        maxLength={this.props.maxLength}
        messageList={this.props.messageList}
        placeholderKey={this.props.placeholderKey}
      />
    )
  }

  onChange = (event) => {
    let value = event.target.value
    switch(this.props.type) {
      case 'Integer':
        if (value && !value.match(/^-{0,1}\d*$/))
          return
        break;
      default:
    }
    this.setState({value: value})
  }

  onSubmit = (event) => {
    if (this.props.value === this.state.value && this.props.onCancel) {
      this.props.onCancel()
      return
    }
    let value = this.state.value.trim()
    switch(this.props.type) {
      case 'Integer':
        if (value && !value.match(/^-{0,1}\d+$/))
          return
        break;
      default:
    }
    this.props.onSubmit(this.state.value)
  }

  handleClickOutside = event => {
    this.onSubmit()
  }
}

export default onClickOutside(TextInputSF)
